import Image from "next/image";
import Link from "next/link";
import { MdFavoriteBorder, MdMenu, MdOutlineShoppingCart, MdSearch } from "react-icons/md";

import remixImage from "public/images/remix.png";

import { useShoppingCart } from "@/hooks/useShoppingCart";

import type { JSX } from "react";

interface Props {
  onOpenSidebar: () => void;
  onOpenSearch: () => void;
}

const iconButtonClassName = "flex h-5 w-5 items-center justify-center rounded-full";

/** Barra superior mobile: menu, logo, busca, favoritos e carrinho. */
export const MobileTopBar = ({ onOpenSidebar, onOpenSearch }: Props): JSX.Element => {
  const { allCartItems } = useShoppingCart({ skipPreCheckout: true });
  const cartItemsCount = allCartItems.length;
  const cartItemsLabel = `${cartItemsCount} ${cartItemsCount === 1 ? "item" : "itens"} no carrinho`;

  return (
    <div className="flex w-full items-center justify-between pb-2 lg:hidden">
      <div className="flex items-center gap-1">
        <button type="button" aria-label="Abrir menu" onClick={onOpenSidebar} className={iconButtonClassName}>
          <MdMenu size="1.5rem" />
        </button>

        <Link href="/">
          <Image src={remixImage} alt="Remix" className="h-auto w-[6.5rem]" sizes="104px" priority />
        </Link>
      </div>

      <div className="flex items-center gap-1">
        <button type="button" aria-label="Buscar" onClick={onOpenSearch} className={iconButtonClassName}>
          <MdSearch size="1.5rem" />
        </button>

        <Link href="/meus-desejos" aria-label="Meus desejos" className={iconButtonClassName}>
          <MdFavoriteBorder size="1.5rem" />
        </Link>

        <Link
          href="/meu-carrinho"
          aria-label={cartItemsLabel}
          className={`${iconButtonClassName} relative bg-brand-primary text-base-white`}
        >
          <MdOutlineShoppingCart size="1.25rem" />
          {cartItemsCount > 0 && (
            <span
              className="absolute -right-2 -top-2 flex min-h-4 min-w-4 items-center justify-center rounded-full bg-red-500 px-1 text-[0.625rem] font-bold leading-none text-base-white"
              aria-hidden="true"
            >
              {cartItemsCount}
            </span>
          )}
        </Link>
      </div>
    </div>
  );
};
